import { GetServerSideProps, NextPage } from 'next';
import React from 'react';

import { pagesConfigStore } from '~/atomic/atom/links/pagesConfigStore';
import { CommonLayout } from '~/atomic/layout/CommonLayout';
import { LayoutType } from '~/atomic/layout/DefaultLayout';
import { PageTemplate } from '~/atomic/organism/PageTemplate/PageTemplate';
import { ContestEverythingWillBeFine } from '~/atomic/page/contest/ContestEverythingWillBeFine';
import { checkAuthToken } from '~/feature/authorization/checkAuthToken';
import { createStore, RootState } from '~/store';

const ContestEverythingWillBeFinePage: NextPage & LayoutType = () => {
  const title = 'Конкурс современных юмористических романов "Все будет хорошо!"';
  const description = 'Проводится совместно АСТ и Букривер. Книги про юмор и позитивные эмоции.';

  return (
    <PageTemplate
      isPublic={pagesConfigStore.contestEverythingWillBeFine.isPublic}
      seo={{
        title,
        description,
        image: `${process.env.NEXT_PUBLIC_BASE_FRONT_URL}/image/contest/everything-will-be-fine/banner.jpg`,
        canonical: pagesConfigStore.contestEverythingWillBeFine.url,
      }}
      content={(
        <ContestEverythingWillBeFine />
      )}
    />
  );
};

ContestEverythingWillBeFinePage.getLayout = (page) => (
  <CommonLayout>{ page }</CommonLayout>
);

export const getServerSideProps: GetServerSideProps<{ state: RootState; }> = async (ctx) => {
  const { store, dispatch } = await createStore();
  const isLoggedIn = await checkAuthToken(ctx, dispatch);

  const state = store.getState();

  return { props: { state } };
};

export default ContestEverythingWillBeFinePage;
